import React from 'react';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import { Card, CardBody, TableScroll } from '../../PanelComerciales.styles';
import SectionHeader from '../SectionHeader/SectionHeader';
import Pagination from '../Pagination/Pagination';
import { ActivityItem, ActivityPage } from 'src/redux/panel_comerciales/panel_comerciales.types';

interface AuditLogProps {
    page: ActivityPage;
    loading: boolean;
    onLoadPage: (offset: number) => void;
}

const fmtDate = (iso: string | null): string =>
    iso ? iso.slice(0, 16).replace('T', ' ') : '—';

/** Texto legible de una entrada del audit log. */
const detailOf = (e: ActivityItem): string => {
    if (e.detailMessage) return e.detailMessage;
    if (e.targetDisplayName) return e.targetDisplayName;
    const field = e.fieldChanged ? `${e.fieldChanged}: ` : '';
    return `${field}${e.oldValue ?? '—'} → ${e.newValue ?? '—'}`;
};

const AuditLog: React.FC<AuditLogProps> = ({ page, loading, onLoadPage }) => (
    <Card>
        <SectionHeader
            title='Actividades recientes'
            subtitle='Historial de cambios recientes.'
            icon={<HistoryOutlinedIcon style={{ color: '#4F46E5' }} />}
            actions={
                <Pagination
                    total={page.total}
                    limit={page.limit}
                    offset={page.offset}
                    onChange={onLoadPage}
                    disabled={loading}
                    label='de actividad'
                />
            }
        />
        <CardBody>
            <TableScroll>
                <table>
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Usuario</th>
                            <th>Acción</th>
                            <th>Detalle</th>
                        </tr>
                    </thead>
                    <tbody>
                        {page.items.map((e) => (
                            <tr key={e.id}>
                                <td style={{ whiteSpace: 'nowrap' }}>{fmtDate(e.performedAt)}</td>
                                <td>{e.userEmail ?? '—'}</td>
                                <td>{e.actionType ?? '—'}</td>
                                <td>{detailOf(e)}</td>
                            </tr>
                        ))}
                        {page.items.length === 0 && (
                            <tr>
                                <td colSpan={4} style={{ textAlign: 'center', padding: 24, color: '#9CA3AF' }}>
                                    Aún no hay actividad registrada.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </TableScroll>
        </CardBody>
    </Card>
);

export default AuditLog;
